import { render, staticRenderFns } from "./ComboEstados.vue?vue&type=template&id=05b0ef32&scoped=true"
import script from "./ComboEstados.vue?vue&type=script&lang=js"
export * from "./ComboEstados.vue?vue&type=script&lang=js"
import style0 from "./ComboEstados.vue?vue&type=style&index=0&id=05b0ef32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b0ef32",
  null
  
)

export default component.exports